import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";

export const documentHeading = new Paragraph({
    children: [
        new TextRun({
            text: "Document Management Information",
            color: "C00000",
            font: "Cambria(Headings)",
            size: 22,
            bold: true,
            italics: false,
            characterSpacing: "0.5pt"
        })
    ],
    alignment: AlignmentType.LEFT,
    spacing: { before: 50, after: 500 },
})

export function documentFirstTable(certInApplicationName) {
    return new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { before: 500 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 23, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Document Title",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],

                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 2, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.RIGHT,
                                children: [
                                    new TextRun({
                                        text: ":",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }

                    }),

                    new TableCell({
                        width: { size: 75, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `Security Audit of Phase 1 Report of ${certInApplicationName} Web Application`,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 23, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Document Status",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 2, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.RIGHT,
                                children: [
                                    new TextRun({
                                        text: ":",
                                        font: "Calibri",
                                        size: 22,
                                        color: "003366",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 75, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Phase 1 Report",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 23, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Abstract",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 2, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.RIGHT,
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.RIGHT,
                                children: [
                                    new TextRun({
                                        text: ":",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }

                    }),

                    new TableCell({
                        width: { size: 75, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { line: 276, after: 40 * 72 * 0.05 },
                                children: [
                                    new TextRun({
                                        text: `The objective of this report is to present the potential vulnerabilities in ${certInApplicationName} Web Application`,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "ffffff",
                            },
                        }
                    }),
                ]
            }),

        ]
    })
}

export const documentHeading2 = new Paragraph({
    children: [
        new TextRun({
            text: "Document Publication History",
            color: "C00000",
            font: "Cambria(Headings)",
            size: 22,
            bold: true,
            italics: false,
            characterSpacing: "0.5pt"
        })
    ],
    alignment: AlignmentType.LEFT,
    spacing: { before: 300, after: 800 },
})

export function documentSecondTable(certInCustomerName, dateString) {

    const [dayStr, monthStr, yearStr] = dateString.split('/');
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10) - 1; // JS months are 0-based
    const year = parseInt(yearStr, 10);

    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
        throw new Error(`Invalid dateString: ${dateString}`);
    }

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const ordinalSuffix = getOrdinalSuffix(day);
    const formattedDay = `${day}${ordinalSuffix} ${monthNames[month]} ${year}`;

    return new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 300 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        },

        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 12, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 220, after: 220 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Version Number",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366", },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 25, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 220, after: 220 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Date",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366", },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 22, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 220, after: 220 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Author(s)",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366", },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 41, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 220, after: 220 },
                                alignment: AlignmentType.CENTER,

                                children: [
                                    new TextRun({
                                        text: "Remark",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366", },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 70, after: 230 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1.0",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 70, after: 230 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: formattedDay,
                                        font: "Calibri",
                                        size: 22
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 70, after: 230 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Kapil Bardewa",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 70, after: 230 },
                                indent: { left: 50, right: 50 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: "This report is based on the discussion and the security assessment executed by",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    }),
                                    new TextRun({
                                        text: " ISECURION",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    }),

                                    new TextRun({
                                        text: " in accordance with ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    }),
                                    new TextRun({
                                        text: `${certInCustomerName}.`,
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    }),

                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                ]
            }),
        ]


    })
}
